<template>
  <transition name="el-fade-in-linear">
    <div class="dashboard-controlbar" :class="[isControlbarVisible ? 'show' : 'hide']" :style="controlStyle">
      <div class="dashboard-controlbar-btn">
        <el-tooltip :content="visibleTooltip" placement="left">
          <el-button  @click="onControlbarChangeVisible">
            <i :class="[isControlbarVisible ? 'fas fa-angle-double-right' : 'fas fa-angle-double-left']" style="color:#fff"></i>
          </el-button>
        </el-tooltip>
      </div>
      <div class="control-tool-panel">
        <el-tooltip content="전체화면 종료" placement="left">
          <div class="fullscreen-control" @click="onFullScreenCloseClick" v-if="isFullScreen"></div>
        </el-tooltip>
        <w-dashboard-download-dropdown v-if="isFullScreen" :dropdownPosition="dropdownPosition" :toolipePosition="toolipePosition" class="dashbord-download-btn"></w-dashboard-download-dropdown>

        <!-- 로테이션 제어 -->
        <el-popover
          v-if="isMonitoringMode"
          :visible-arrow="false"
          placement="left-start"
          trigger="hover"
          popper-class="rotation-select-popper"
          >
          <el-radio-group v-model="rotationControl">
            <div class="rotation-btn" v-for="index in DashboardConst.ROTATION.MAX" :key="index">
              <el-radio :label="index">{{ `로테이션 ${index}` }}</el-radio>
            </div>
          </el-radio-group>
          <div class="rotation-control" slot="reference">
            <i class="far fa-dot-circle"></i>
          </div>
        </el-popover>
        <!-- 스케일맞춤 -->
        <el-tooltip content="스케일맞춤" placement="left">
          <div class="fullscale-control" @click="onFullScaleClick" :class="[isFullScale ? 'enabled' : '']">
            <i class="fas fa-expand"></i>
          </div>
        </el-tooltip>
        <!-- 확대/축소 -->
        <div :class="['zoomout-control', (isFullScale ? 'disable' : '')]">
          <el-tooltip content="확대" placement="left">
            <div class="zoomout-btn zoom" @click="onZoomoutClick('zoom')">
              <i class="fas fa-plus"></i>
            </div>
          </el-tooltip>
          <div class="slider map-slider-shape">
            <el-slider
              vertical
              height="100px"
              v-model="tmpDashboardScale"
              :disabled="isFullScale"
              :min="DashboardConst.COORD_LAYOUT_OPTION.MIN_SCALE"
              :max="DashboardConst.COORD_LAYOUT_OPTION.MAX_SCALE"
              :step="DashboardConst.COORD_LAYOUT_OPTION.SCALE_STEP"
              :format-tooltip="sliderTooltip">
            </el-slider>
          </div>
          <el-tooltip content="축소" placement="left">
            <div class="zoomout-btn out" @click="onZoomoutClick('out')">
              <i class="fas fa-minus"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { min, max } from 'lodash';

import DashboardConst from '@/constants/dashboard';

import Base from '@/mixins/dashboard/base';
import WDashboardDownloadDropdown from '@/views/dashboard/components/DashboardDownloadDropdown';

export default {
  name: 'WDashboardControlbar',
  components: {
    WDashboardDownloadDropdown,
  },
  mixins: [Base],
  props: {
    dashboardScale: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      DashboardConst,
      toolipePosition: 'left',
      dropdownPosition: 'left',
    };
  },
  computed: {
    visibleTooltip() {
      return this.isControlbarVisible ? '컨트롤바 숨기기' : '컨트롤바 보이기';
    },
    tmpDashboardScale: {
      get() {
        return this.dashboardScale;
      },
      set(value) {
        this.$emit('update:dashboardScale', value);
      },
    },
    controlStyle() {
      return {
        top: this.isFullScreen ? '5px' : '130px',
      };
    },
    rotationControl: {
      get() {
        return this.currentRotationInfo.childNumber;
      },
      set(value) {
        this.setRotation(1, value);
      },
    },
  },
  beforeDestroy() {
    const layout = document.querySelector('.coord-dashboard-layout');
    if (layout) {
      layout.removeEventListener('mousemove', this.onMouseMove);
    }
  },
  methods: {
    onFullScaleClick() {
      this.$store.commit('setDashboardFullScale', !this.isFullScale);
    },
    onFullScreenCloseClick() {
      this.$confirm('전체화면을 종료하시겠습니까?', '확인', {
        confirmButtonText: '예',
        cancelButtonText: '아니오',
        confirmButtonClass: 'el-button--solid',
        closeOnPressEscape: false,
      })
        .then(() => {
          this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN_CLOSE);
        })
        .catch(() => {})
        .finally(() => {});
    },
    /**
     * 확대/축소 슬라이더 툴팁
     * @author KangBonghun(toto1323)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    sliderTooltip(value) {
      return `${Math.floor(value * 100)}%`;
    },
    onZoomoutClick(type) {
      if (type === 'zoom') {
        this.tmpDashboardScale = min([this.tmpDashboardScale + DashboardConst.COORD_LAYOUT_OPTION.SCALE_STEP, DashboardConst.COORD_LAYOUT_OPTION.MAX_SCALE]);
      } else {
        this.tmpDashboardScale = max([this.tmpDashboardScale - DashboardConst.COORD_LAYOUT_OPTION.SCALE_STEP, DashboardConst.COORD_LAYOUT_OPTION.MIN_SCALE]);
      }
    },
    onControlbarChangeVisible() {
      this.$store.commit('setCoordDashboardControlbar', !this.isControlbarVisible);
    },
  },
};
</script>

<style lang="scss">
@mixin disable() {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
  z-index: 9999;
  cursor: not-allowed;
}

.dashboard-controlbar {
  position: fixed;
  right: 20px;
  z-index: 1000;

  .control-tool-panel {
    right: 0px;
    position: relative;
    padding: 8px 0 0px;
    box-sizing: border-box;
    transition: all .2s ease-out;

    .dashbord-download-btn {
      margin-bottom: 10px;
      button {
        width: 35px;
        height: 35px;
      }
    }

    .fullscreen-control {
      cursor: pointer;
      width: 35px;
      height: 35px;
      text-align: center;
      vertical-align: middle;
      line-height: 35px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 3px;
      margin-bottom: 50px;
      color: #fff;

      &:hover {
        background: #000;
      }

      &:before, &:after {
        position: absolute;
        left: 17px;
        content: ' ';
        height: 25px;
        width: 1px;
        background-color: #fff;
        top: 13px;
      }
      &:before {
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }
    }

    .rotation-control {
      width: 35px;
      height: 35px;
      text-align: center;
      vertical-align: middle;
      line-height: 35px;
      background: #fff;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 3px;
      margin-bottom: 10px;
    }

    .fullscale-control {
      cursor: pointer;
      width: 35px;
      height: 35px;
      text-align: center;
      vertical-align: middle;
      line-height: 35px;
      background: #fff;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 3px;
      margin-bottom: 10px;

      &.enabled {
        background-color: #38608E;
        color: #fff;
      }
    }

    .zoomout-control {
      position: relative;
      float: left;
      width: 35px;
      border-radius: 3px;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      background: #fff;

      .zoomout-btn {
        float: left;
        cursor: pointer;
        width: 35px;
        height: 35px;
        text-align: center;
        vertical-align: middle;
        line-height: 35px;

        &.zoom {
          border-bottom: 1px solid rgb(226, 226, 226);
          border-radius: 3px 3px 0px 0px;
        }
        &.out {
          border-top: 1px solid rgb(226, 226, 226);
          border-radius: 0px 0px 3px 3px;
        }
      }

      .slider {
        float: left;
        padding: 10px 0px;
      }

      &.disable::after {
        @include disable();
      }
    }
  }
  &.hide {
    .control-tool-panel {
      right: -60px;
    }
  }

  &-btn {
    height:15px;
    position: relative;
    right: -35px;

    button {
      border: 0px;
      height: 15px;
      min-width: 100%;
      opacity: 0.5;
      background: #555 !important;
      border-radius: 10px 0px 0px 10px;
    }
    span {
      right: 6px;
      top: -5px;
    }

    &:hover {
      button {
        opacity: 1;
      }
    }
  }
}

.rotation-select-popper {
  min-width: auto;
  .rotation-btn {
    padding: 5px 5px 5px 5px;
    .el-radio:hover {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/DashboardControlbar.vue